;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Controller = APP.module('Controller');
	const Router     = APP.module('Router');
	const Model      = APP.module('Model');
	const View       = APP.module('View');
	const Layout     = APP.module('Layout');
	const Collection = APP.module('Collection');

	Controller.LoginForm = Marionette.Controller.extend({
		initialize: function() {
			this.builderOpt = new Model.LoginFormBuilder().toJSON();
		},

		index: function() {
			let layout_name  = this.builderOpt.layout_login ? this.builderOpt.layout_login : 'LoginFormLeft',
				footer       = this.builderOpt.footer_content_view ? this.builderOpt.footer_content_view : false,
				loginLayout  = new Layout[layout_name](),
				widgets_list = this.builderOpt.side_bar_widgets.length ? this.builderOpt.side_bar_widgets : false,
				loginView    = new View.LoginForm({
					model:           new Model.User(),
					facebookModel:   new Model.FacebookLoginForm(),
					facebookConnect: new Model.FacebookConnect(),
					game:            this.builderOpt.game,
					builderOpt:      this.builderOpt
				});

			APP.main.show(loginLayout);
			loginLayout.main.show(loginView);

			if(this.builderOpt.side_bar_enabled){

				let widget_opts = {
					rounds:           new Collection.Rounds(),
					squads:           new Collection.Squads(),
					ladderCollection: new Collection.TippingLadder(),
					model:            new Model.Ladder(),
					official:         true
				};

				let sidebar = new Layout.Sidebar({
					widgets_list: widgets_list,
					widgets_options: widget_opts
				});

				loginLayout.aside.show(sidebar);
			}

			footer && APP.footer.show(new View[footer]());
		},

		SSOInitiate: function() {
			function dec2hex(dec) {
				return ("0" + dec.toString(16)).substr(-2);
				}

			function generateRandomString() {
				var array = new Uint32Array(56 / 2);
				window.crypto.getRandomValues(array);
				return Array.from(array, dec2hex).join("");
			}

			function sha256(plain) {
				// returns promise ArrayBuffer
				const encoder = new TextEncoder();
				const data = encoder.encode(plain);
				return window.crypto.subtle.digest("SHA-256", data);
			}

			function base64urlencode(a) {
				var str = "";
				var bytes = new Uint8Array(a);
				var len = bytes.byteLength;
				for (var i = 0; i < len; i++) {
					str += String.fromCharCode(bytes[i]);
				}
				return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
			}

			function challenge_from_verifier(v) {
				return sha256(v).then((hashed) => base64urlencode(hashed));
			}

			var redirect_uri = `${CONFIG.ABSPATH}callback.html`;
			var	client_id = CONFIG.AFL_ID_CLIENT_ID;
			var verifier = generateRandomString();
			localStorage.setItem("code_verifier", verifier);
			localStorage.setItem("client_id", CONFIG.AFL_ID_CLIENT_ID);
			localStorage.setItem("redirect_uri", `${CONFIG.ABSPATH}callback.html`);
			var nonce = generateRandomString();
			var myState = generateRandomString();
			var code_challenge;

			challenge_from_verifier(verifier).then((res) => {
				code_challenge = res;

				const link = CONFIG.ENVIRONMENT === 'production' ? 'login.id.afl' : 'id.test.afl';

				window.location.href = `https://${link}/oauth2/v1/authorize?
					scope=openid email profile
					&response_type=code
					&redirect_uri=${redirect_uri}
					&state=${myState}
					&nonce=${nonce}
					&client_id=${client_id}
					&code_challenge=${code_challenge}
					&code_challenge_method=S256`
			  });
		},

		SSOLoginCallbackCtrl: function(code) {
			let layout  = this.builderOpt.layout_login ? this.builderOpt.layout_login : 'LoginFormLeft',
				footer       = this.builderOpt.footer_content_view ? this.builderOpt.footer_content_view : false,
				SSOLoginView = new View.SSOLoginCallback({
					model:           new Model.User(),
					facebookModel:   new Model.FacebookLoginForm(),
					facebookConnect: new Model.FacebookConnect(),
					game:            this.builderOpt.game,
					builderOpt:      this.builderOpt
				}),
				loginLayout = new Layout[layout]();

			APP.main.show(loginLayout);
			loginLayout.main.show(SSOLoginView);

			footer && APP.footer.show(new View[footer]());
		},

		// SSOLoginRegisterCtrl: function(code) {
		// 	console.log(7171, code);
		// 	let layout  = this.builderOpt.layout_login ? this.builderOpt.layout_login : 'LoginFormLeft',
		// 		footer       = this.builderOpt.footer_content_view ? this.builderOpt.footer_content_view : false,
		// 		SSORegisterView = new View.SSOLoginRegister({
		// 			model:           new Model.User(),
		// 			facebookModel:   new Model.FacebookLoginForm(),
		// 			facebookConnect: new Model.FacebookConnect(),
		// 			game:            this.builderOpt.game,
		// 			builderOpt:      this.builderOpt
		// 		}),
		// 		loginLayout = new Layout[layout]();

		// 	APP.main.show(loginLayout);
		// 	loginLayout.main.show(SSORegisterView);

		// 	footer && APP.footer.show(new View[footer]());
		// },

		forgotPassword: function() {
			var layout =  this.builderOpt.layout_send_token ? this.builderOpt.layout_send_token : 'LoginFormLeft',
				footer = this.builderOpt.footer_content_view ? this.builderOpt.footer_content_view : false,
				sendTokenView = new View.SendToken({
					model: new Model.SendToken(),
					options: this.builderOpt
				}),
				loginLayout = new Layout[layout]();

			APP.main.show(loginLayout);
			loginLayout.main.show(sendTokenView);

			footer && APP.footer.show(new View[footer]());
		},
		passwordRecovery: function(queryString) {

			var params = this.parseQueryString(queryString);

			if(params && typeof params.token === 'undefined'){
				return;
			}

			var layout =  this.builderOpt.layout_password_recovery ? this.builderOpt.layout_password_recovery : 'LoginFormLeft',
				footer = this.builderOpt.footer_content_view ? this.builderOpt.footer_content_view : false,
				recovery_user = params['recover'] ? Boolean(params['recover']) : false,
				widgets_list = this.builderOpt.side_bar_widgets.length ? this.builderOpt.side_bar_widgets : false,
				ChangePassword = new View.PasswordRecovery({
					model: new Model.ChangePassword({token:params.token}),
					recovered: recovery_user
				}),
				loginLayout = new Layout[layout]();

			APP.main.show(loginLayout);
			loginLayout.main.show(ChangePassword);

			if(this.builderOpt.side_bar_enabled){
				var sidebar = new Layout.Sidebar({
					widgets_list: widgets_list,
					widgets_options: {
						rounds:           new Collection.Rounds(),
						squads:           new Collection.Squads()
					}
				});
				loginLayout.aside.show(sidebar);
			}

			footer && APP.footer.show(new View[footer]());
		},
		parseQueryString: function(queryString){
			var params = {};
			if(queryString){
				_.each(
					_.map(decodeURI(queryString).split(/&/g),function(el,i){
						var aux = el.split('='), o = {};
						if(aux.length >= 1){
							var val = undefined;
							if(aux.length == 2)
								val = aux[1];
							o[aux[0]] = val;
						}
						return o;
					}),
					function(o){
						_.extend(params,o);
					}
				);
			}
			return params;
		},
		unsubscribe: function(query, email, token, notification){

			var query_obj = this.parseQueryString(query);

			if(typeof query_obj.token === 'undefined' || typeof query_obj.email === 'undefined'){
				return;
			}

			this.user  = APP.module('instance').user;

			if(!query_obj.notification){
				query_obj.notification = '';
			}

			APP.setJStorage('backTo', '#account/notifications');

			this.loginFormBuilderModel = new Model.LoginFormBuilder();
			this.unsubscribeModel = new Model.Unsubscribe();
			this.unsubscribeModel.set({email: query_obj.email, token: query_obj.token, notification: query_obj.notification});
			var notification_text = query_obj.notification.length ? query_obj.notification.replace("_", " ") : 'All';
			var user_game_type = this.loginFormBuilderModel.get('game'),
				client = this.loginFormBuilderModel.get('client');

			APP.vent.on('popup:message:closed' , _.bind(function(){

				if(this.user.get('id')){
					APP.vent.trigger('user:get:get_extra_data', this.user.toJSON());
				}

			}, this));

			var link_click_event = "onClick='APP.vent.trigger(\"popup:message:close_action\")'";

			$.when.call(null, this.unsubscribeModel.save()).then(function(response){

				if(response.errors.length){
					APP.vent.trigger('popup:message:show', response.errors[0].text, 'Error');
				}
				else {

					APP.vent.trigger('popup:message:show', 'You have been unsubscribed from the '+ notification_text +' emails of all '+client+' '+ user_game_type +' games. You can manage your email notifications on the <a href="javaScript:void(0);" '+ link_click_event +'>Account Settings</a>  page.', 'Unsubscribe');
				}

			});
		},
		sendRecoveryTokenConfirmation: function(){

			var
				layout = 'LoginFormLeft',
				sendRecoveryTokenConfirmation = new View.SendRecoveryTokenConfirm(),
				loginLayout = new Layout[layout](),
				footer = this.builderOpt.footer_content_view ? this.builderOpt.footer_content_view : false,
				widgets_list = this.builderOpt.side_bar_widgets.length ? this.builderOpt.side_bar_widgets : false
				;

			APP.main.show(loginLayout);
			loginLayout.main.show(sendRecoveryTokenConfirmation);

			if(this.builderOpt.side_bar_enabled){
				var sidebar = new Layout.Sidebar({
					widgets_list: widgets_list,
					widgets_options: {
						rounds:           new Collection.Rounds(),
						squads:           new Collection.Squads()
					}
				});
				loginLayout.aside.show(sidebar);
			}

			footer && APP.footer.show(new View[footer]());
		},


		indexOffSeason: function() {
			var layout =  this.builderOpt.layout_login ? this.builderOpt.layout_login : 'LoginFormLeft',
				footer = this.builderOpt.footer_content_view ? this.builderOpt.footer_content_view : false,
				loginLayout = new Layout[layout](),
				widgets_list = this.builderOpt.side_bar_widgets.length ? this.builderOpt.side_bar_widgets : false,
				loginView = new View.LoginForm(
					{
						model: new Model.User(),
						facebookModel: new Model.FacebookLoginForm(),
						facebookConnect: new Model.FacebookConnect(),
						game:  this.builderOpt.game
					}
				);
			APP.main.show(loginLayout);
			loginLayout.main.show(loginView);

			if(this.builderOpt.side_bar_enabled){

				var widget_opts = {
					rounds:           new Collection.Rounds(),
					squads:           new Collection.Squads(),
					ladderCollection: new Collection.TippingLadder(),
					model:            new Model.Ladder(),
					official:         true
				};

				var sidebar = new Layout.Sidebar({
					widgets_list: widgets_list,
					widgets_options: widget_opts
				});

				loginLayout.aside.show(sidebar);
			}

			footer && APP.footer.show(new View[footer]());
		}
	});

	APP.on('start', function() {
		var controller = new Controller.LoginForm();
		var router = new Router.LoginForm({ controller: controller });
	});

}(window, APP, Backbone, Marionette, $, _));
